import { getGlobalI18nInstance } from '@mc/i18n'
import { getNumberOfInstructors } from '@mc/instructors'

const i18nInstance = getGlobalI18nInstance()
const t = i18nInstance.getFixedT(null, '@mc/next')

export const ITEMS = [
  {
    kind: 'lessons',
    text: t('guestPassRecipient.valueProps.items.item1', {
      numberInstructors: getNumberOfInstructors(),
    }),
  },
  {
    kind: 'lessons',
    text: t('guestPassRecipient.valueProps.items.item3'),
  },
  {
    kind: 'download',
    text: t('guestPassRecipient.valueProps.items.item4'),
  },
  {
    kind: 'star',
    text: t('guestPassRecipient.valueProps.items.item5'),
  },
]
